import { create } from "zustand";

/**
 * What a host's request to start this app's checkout answered.
 * - `leaving`: the page goes to the checkout.
 * - `refused`: no checkout started. `message` is a sentence for the shopper.
 */
export type CheckoutStartOutcome = { status: "leaving" } | { status: "refused"; message: string };

export const BAG_EMPTY = "Your bag is empty.";
export const CHECKOUT_NOT_STARTED = "We could not start your checkout. Please try again.";

interface CheckoutStartState {
  /** The hosts that wait for a start. One start answers all of them. */
  waiting: Array<(outcome: CheckoutStartOutcome) => void>;
  /** Goes up with each request, so the bag drawer runs again. */
  requestId: number;
  /** Remove and give the hosts that wait. Each is taken once. */
  take: () => Array<(outcome: CheckoutStartOutcome) => void>;
}

export const useCheckoutStart = create<CheckoutStartState>((set, get) => ({
  waiting: [],
  requestId: 0,
  take: () => {
    const { waiting } = get();
    if (waiting.length) set({ waiting: [] });
    return waiting;
  },
}));

/** Ask the bag drawer to start the checkout. The drawer runs it when it is mounted. */
export function requestCheckoutStart(): Promise<CheckoutStartOutcome> {
  return new Promise((settle) =>
    useCheckoutStart.setState((state) => ({ waiting: [...state.waiting, settle], requestId: state.requestId + 1 })),
  );
}
